module.exports = __webpack_public_path__ + "static/media/MISSION.c49919c5.jpg";